<template>
    <pop-form v-if="state" width="450px" class="set-pay-password">
        <template v-slot:title>
            {{title}}
            <i class="el-icon-close close" @click="close()"></i>
        </template>

        <div class="form-box">
            <el-form ref="form" :model="formData" label-width="100px">
                <el-form-item label="原始密码" prop="oldPass">
                    <el-input v-model="formData.oldPass" placeholder="" type="password"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPass">
                    <el-input v-model="formData.newPass" placeholder="" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="newPass2">
                    <el-input v-model="formData.newPass2" placeholder="" type="password"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <template v-slot:foot>
            <div class="tr foot-box">
                <el-button size="medium" type="primary" @click="submitForm">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
            </div>
        </template>
    </pop-form>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "SetPayPassword",
        components: {PopForm},
        props: {
            state: {
                type: Boolean,
                default: false
            },
            storeUid: [Number, String]
        },
        model: {
            prop: "state",
            event: "showChange"
        },
        data: () => ({
            title: "修改消费密码",
            formData: {
                oldPass: "",
                newPass: "",
                newPass2: "",
            }
        }),
        methods: {
            initData: function () {
                this.formData = {
                    oldPass: "",
                    newPass: "",
                    newPass2: "",
                };
            },
            //关闭
            close: function () {
                this.$emit("showChange", false);
            },
            //提交修改支付密码
            submitForm: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return false;

                    if(this.formData.newPass !== this.formData.newPass2){
                        obj.message.error("两次新密码输入不一致");
                        return false;
                    }

                    let postData = {
                        store_uid: this.storeUid,
                        old_pass: this.formData.oldPass,
                        new_pass: this.formData.newPass
                    };
                    obj.postData("store_user/set_pay_password", postData, res => {
                        if(res.errcode === 0){
                            obj.message.success("支付密码修改成功");
                            this.close();
                        } else {
                            obj.message.error(res.errdesc);
                        }
                    });
                });
            }
        },
        watch: {
            state: function (t) {
                if(t) this.initData();
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
    }
    .form-box{
        padding-right: 20px;
    }
    .foot-box{
        padding-right: 10px;
    }

</style>
<style>
    .see-pay-password .el-card__header{
        border-bottom: none;
    }
</style>
